<script lang="ts">
  import TextArea from '$components/reusable/TextArea.svelte';
  import DropdownInput from '$components/reusable/dropdowns/DropdownInput.svelte';
  import { ENGINEERING_ROLES, ROLES, SKILLS, USE_CASES } from '$utils/constants';
  import SegmentedControl from '$components/reusable/SegmentedControl.svelte';
  import Notification from '$components/reusable/Notification.svelte';
  import type { Infer, SuperForm } from 'sveltekit-superforms/client';
  import type { editProfileSchema } from '$shared/lib';

  export let superform: SuperForm<Infer<typeof editProfileSchema>>;
  const { form, errors, enhance, constraints } = superform;
</script>

<form method="POST" use:enhance class="space-y-2xl p-[3px]">
  <DropdownInput
    multiple
    label="Crypto use cases you're interested in"
    items={USE_CASES}
    bind:selectedValues={$form.interestedUseCases}
    bind:errors={$errors.interestedUseCases}
    bind:constraints={$constraints.interestedUseCases}
  />
  <DropdownInput
    multiple
    label="Professional roles"
    items={ROLES}
    bind:selectedValues={$form.yourRoles}
    bind:errors={$errors.yourRoles}
    bind:constraints={$constraints.yourRoles}
  />
  {#if $form.yourRoles?.some((role) => ENGINEERING_ROLES.has(role))}
    <DropdownInput
      multiple
      label="Technical skills"
      items={SKILLS}
      bind:selectedValues={$form.yourSkills}
      bind:errors={$errors.yourSkills}
      bind:constraints={$constraints.yourSkills}
    />
  {/if}
  <SegmentedControl
    label="Are you interested in finding a cofounder or hackathon team?"
    bind:value={$form.lookingForCollab}
    items={[{ No: false }, { Yes: true }]}
  />
  {#if $form.lookingForCollab}
    <TextArea
      label="Describe what you're interested in building"
      description="This is your short pitch to a team or cofounder(s). If you're open to anything, you can let them know that too."
      bind:value={$form.lookingToBuild}
      bind:errors={$errors.lookingToBuild}
      bind:constraints={$constraints.lookingToBuild}
    />
    <DropdownInput
      optional
      multiple
      label="Roles you're looking for"
      items={ROLES}
      bind:selectedValues={$form.rolesLookingFor}
      bind:errors={$errors.rolesLookingFor}
      bind:constraints={$constraints.rolesLookingFor}
    />
  {:else}
    <Notification
      informational
      title="If you're already working with a team, please make sure each member creates an account!"
      class="w-full"
    />
  {/if}
</form>
